export interface CustomerFormState {
  businessName: string;
  businessAddress: string;
  businessAddress2?: string;
  businessCity: string;
  businessState: States;
  businessZipCode: string;
  businessType: BusinessType;
  businessPhone: string;
  businessEmail: string;
  servicesOffered: ServicesOffered[];
}

export type BusinessType = 'sandbox' | 'marketplace';
export type ServicesOffered =
  | 'nail'
  | 'hair'
  | 'spa'
  | 'pets'
  | 'tattoos'
  | 'others';
export type Status = 'draft' | 'active' | 'inactive';

export const STATES_LIST: string[] = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export type States = (typeof STATES_LIST)[number];

export const SERVICES_OFFERED_LIST: ServicesOffered[] = [
  'nail',
  'hair',
  'spa',
  'pets',
  'tattoos',
  'others',
];

export const BUSINESS_TYPES: BusinessType[] = ['sandbox', 'marketplace'];

export interface DayWorkingHours {
  open?: string;
  close?: string;
  closed: boolean;
}

export interface WorkingHours {
  monday: DayWorkingHours;
  tuesday: DayWorkingHours;
  wednesday: DayWorkingHours;
  thursday: DayWorkingHours;
  friday: DayWorkingHours;
  saturday: DayWorkingHours;
  sunday: DayWorkingHours;
}

export interface HolidayHour {
  id: string;
  date: string;
  name: string;
  closed: boolean;
  open?: string;
  close?: string;
  description?: string;
}

export interface DayOffHour {
  date: string;
  closed: boolean;
  open?: string;
  close?: string;
  description?: string;
}

export interface BusinessInformationDto {
  storeGroupId: string;
  website?: string;
  zipCode: string;
  address: string;
  address2?: string;
  city: string;
  state: States;
  storeName: string;
  staffIds: string[];
  ownerId: string;
  phoneNumber: string;
  workingHours: WorkingHours;
  holidayHours: HolidayHour[];
  dayOffHours: DayOffHour[];
  description: string;
  type: ServicesOffered[];
  storeLogo: string;
  banner: string;
  galleryPhotos: string[];
  maxStaffCount: number;
  activeStaffCount: number;
  isSandbox: boolean;
  adminIds: string[];
  status: Status;
  latitude: number;
  longitude: number;
  email: string;
  smsPhoneNumber?: string;
}

export interface CustomerFormDtoTotal extends CustomerFormState {
  repId: string;
  status: Status;
}

export interface CustomerFormEntity extends CustomerFormDtoTotal {
  id: string;
  createdTime: string;
  modifiedTime: string;
}

export const WORKING_HOURS_MOCK: WorkingHours = {
  monday: { open: '09:00', close: '17:00', closed: false },
  tuesday: { open: '09:00', close: '17:00', closed: false },
  wednesday: { open: '09:00', close: '17:00', closed: false },
  thursday: { open: '09:00', close: '17:00', closed: false },
  friday: { open: '09:00', close: '17:00', closed: false },
  saturday: { open: '10:00', close: '14:00', closed: false },
  sunday: { open: '10:00', close: '14:00', closed: false }
};

export const WORKING_EXCEPTIONS_MOCK: {
  holidayHours: HolidayHour[];
  dayOffHours: DayOffHour[];
} = {
  holidayHours: [
    {
      id: '1',
      date: '2025-01-01',
      name: 'New Year\'s Day',
      closed: true,
      open: '10:00',
      close: '14:00',
      description: 'Closed for New Year\'s Day'
    },
    {
      id: '2',
      date: '2025-07-04',
      name: 'Independence Day',
      closed: false,
      open: '10:00',
      close: '14:00',
      description: 'Shortened hours for Independence Day'
    }
  ],
  dayOffHours: [
    {
      date: '2025-06-25',
      closed: true,
      open: '12:00',
      close: '16:00',
      description: 'Company Retreat'
    },
    {
      date: '2025-07-10',
      closed: false,
      open: '12:00',
      close: '16:00',
      description: 'Staff meeting in the morning'
    }
  ]
};

export interface UserProfileEntity {
  id: string;
  accessNumber: string;
  displayName: string;
  email: string;
  firstName: string;
  gender: string;
  lastName: string;
  phoneNumber: string;
  photoURL: string;
  providerData?: {
    providerId?: string;
    uid?: string;
  };
  roles: string[];
}
